import { useState } from "react";
import { PERSONAS, slotOf, type DepartmentDef, type RoleDef } from "../data/org";
import { useRH } from "../store/rh";
import { useCustomOrg } from "../store/customOrg";
import { PersonaCard } from "./PersonaCard";

export function RoleColumn({ dept, role, custom = false }:
  { dept: DepartmentDef; role: RoleDef; custom?: boolean }) {

  const slotId = slotOf(dept.id, role.id);
  const hiredIds  = useRH(s => s.hiredAtSlot(slotId));
  const employees = useRH(s => s.employees);
  const moveAgent = useRH(s => s.moveAgent);
  const removeRole = useCustomOrg(s => s.removeRole);

  const [dragOver, setDragOver] = useState(false);

  // Nativas: PERSONAS cujo slotId original bate, com lógica de exclusão de quem foi movida pra fora
  const nativeShown = PERSONAS.filter(p => p.slotId === slotId).filter(p => {
    const emp = employees[p.id];
    if (!emp || emp.status !== "hired") return true;           // available/fired ficam no slot original
    return (emp.slotOverride ?? p.slotId) === slotId;          // hired: só fica se efetivo == aqui
  });
  // Personas movidas PRA cá vindas de outros slots
  const movedIn = PERSONAS.filter(p => {
    if (p.slotId === slotId) return false;
    const emp = employees[p.id];
    return emp?.status === "hired" && emp.slotOverride === slotId;
  });

  const candidates = [...nativeShown, ...movedIn];
  const occ = hiredIds.length;
  const cap = role.capacity;
  const full = occ >= cap;

  const onDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setDragOver(false);
    const personaId = e.dataTransfer.getData("text/persona");
    if (!personaId) return;
    const cur = employees[personaId];
    const currentSlot = cur?.slotOverride ?? PERSONAS.find(p => p.id === personaId)?.slotId;
    if (currentSlot === slotId) return;
    const err = moveAgent(personaId, slotId);
    if (err) alert(err);
  };

  return (
    <div
      className={`border bg-bone transition
        ${dragOver ? "border-red border-2 bg-red/5" : "border-ink/20"}`}
      onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
      onDragLeave={() => setDragOver(false)}
      onDrop={onDrop}
    >
      <div className="flex items-center justify-between px-3 py-2 border-b border-ink/20">
        <div className="flex items-center gap-2">
          <span className={`inline-block w-3 h-3 ${full ? "bg-red" : "bg-ink"}`} />
          <div className="font-display font-bold uppercase text-base leading-none">
            {role.title}
          </div>
          {custom && <span className="tag bg-gold text-ink px-1.5">custom</span>}
        </div>
        <div className="flex items-center gap-2">
          <div className="tag font-mono">{occ}/{cap}</div>
          {custom && (
            <button
              onClick={() => { if (confirm(`Remover cargo "${role.title}"?`)) removeRole(role.id); }}
              className="tag text-red underline">×</button>
          )}
        </div>
      </div>

      <div className="p-2 space-y-2 min-h-[60px]">
        {candidates.length === 0 && (
          <div className="text-center py-3 font-crimson italic text-graymd text-xs">
            arraste agentes pra cá
          </div>
        )}
        {candidates.map(p => <PersonaCard key={p.id} persona={p} />)}
      </div>
    </div>
  );
}
